'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';

type ImageUploadOverlayProps = {
  onRemove: () => void;
  disabled?: boolean;
};

const ImageUploadOverlay = ({ onRemove, disabled }: ImageUploadOverlayProps) => {
  return (
    <Box
      className="image-upload-overlay"
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        opacity: 0,
        transition: 'opacity 0.2s',
        borderRadius: 1,
      }}
    >
      <Typography variant="body2" sx={{ color: 'white', mb: 1 }}>
        Change image
      </Typography>
      <Button
        size="small"
        variant="outlined"
        startIcon={<DeleteIcon />}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        disabled={disabled}
        sx={{
          color: 'white',
          borderColor: 'rgba(255, 255, 255, 0.7)',
          '&:hover': {
            borderColor: 'white',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        Remove
      </Button>
    </Box>
  );
};

export default ImageUploadOverlay;
